"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBaseError = toBaseError;
const BadGatewayError_1 = require("./BadGatewayError");
const BaseError_1 = require("./BaseError");
const ConflictError_1 = require("./ConflictError");
const ForbiddenError_1 = require("./ForbiddenError");
const GatewayTimeoutError_1 = require("./GatewayTimeoutError");
const InternalServerError_1 = require("./InternalServerError");
const InvalidRequestError_1 = require("./InvalidRequestError");
const MethodNotAllowedError_1 = require("./MethodNotAllowedError");
const NotFoundError_1 = require("./NotFoundError");
const NotImplementedError_1 = require("./NotImplementedError");
const ServiceUnavailableError_1 = require("./ServiceUnavailableError");
const TooManyRequestsError_1 = require("./TooManyRequestsError");
const UnauthorizedError_1 = require("./UnauthorizedError");
const errorsByStatus = {
    400: InvalidRequestError_1.InvalidRequestError,
    401: UnauthorizedError_1.UnauthorizedError,
    403: ForbiddenError_1.ForbiddenError,
    404: NotFoundError_1.LangfuseNotFoundError,
    405: MethodNotAllowedError_1.MethodNotAllowedError,
    409: ConflictError_1.LangfuseConflictError,
    429: TooManyRequestsError_1.TooManyRequestsError,
    500: InternalServerError_1.InternalServerError,
    501: NotImplementedError_1.NotImplementedError,
    502: BadGatewayError_1.BadGatewayError,
    503: ServiceUnavailableError_1.ServiceUnavailableError,
    504: GatewayTimeoutError_1.GatewayTimeoutError,
};
/** toBaseError maps an HTTP status to its base error, or to a plain BaseError with that status when none is mapped. */
function toBaseError(status, message) {
    const ErrorClass = errorsByStatus[status];
    if (!ErrorClass) {
        return new BaseError_1.BaseError("HttpError", status, message ?? `HTTP ${status}`, true);
    }
    return new ErrorClass(message);
}
